import FAQS from './FAQS'
export default FAQS